export default [
    {
    	start: 18000,
    	previous: 0,
        scrollDistance: 20000
    },
    // {
    // 	start: 21800,
    // 	previous: 20000,
    //     scrollDistance: 24000
    // },
    {
    	start: 25000,
    	previous: 20000,
        scrollDistance: 28000
    },
    {
    	start: 29000,
    	previous: 28000,
        scrollDistance: 30800
    },
    {
    	start: 31100,
    	previous: 29000,
        scrollDistance: 33000
    },
    {
    	start: 34100,
    	previous: 31800,
        scrollDistance: 35700
    },
    {
    	start: 37200,
    	previous: 34100,
        scrollDistance: 37500
    },
    {
    	start: 38800,
    	previous: 37500,
        scrollDistance: 39500
    },
];
